import businesspool from './businesspool';
import userpool from './userpool';

export const getUserPool = () => {
    const businesspoolUser = businesspool.getCurrentUser();
    const userpoolUser = userpool.getCurrentUser();
    if (businesspoolUser) {
        return businesspool;
    } else if (userpoolUser) {
        return userpool;
    } else {
        return null;
    }
};